"use client";

import React, { useContext } from "react";

interface ProductTileClickData {
  productLinkProps:
    | {
        productUrl: string;
        replace?: boolean;
      }
    | undefined;
  onProductClick: () => void;
}

export const ProductTileClickContext =
  React.createContext<ProductTileClickData>({
    productLinkProps: { productUrl: "" },
    onProductClick: () => {},
  });

export const useProductTileClickProps = (): ProductTileClickData => {
  return useContext(ProductTileClickContext);
};
